/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import {MsalGuard} from "@azure/msal-angular";

const routes: Routes = [
  {
    path: "",
    canActivate: [MsalGuard],
    canActivateChild: [],
    loadChildren: () =>
      import("../app/pages/pages.module").then((m) => m.PagesModule),
  },
  { path: "**", redirectTo: "" },
];

const isIframe = window !== window.parent && !window.opener

const config: ExtraOptions = {
  useHash: true,
  relativeLinkResolution: "legacy",
  initialNavigation: !isIframe ? 'enabled' : 'disabled' // Don't perform initial navigation in iframes
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
